import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TOPIC_OVERVIEW_CONVERTER_TOKEN, TopicOverviewConverter } from './topic-overview.component.converter'
import {
  TOPIC_OVERVIEW_ITEM_CONVERTER_TOKEN, TopicOverviewItemConverter
} from './topic-overview-item/topic-overview-item.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        topicOverviewFeature: {
          module: () => import('./topic-overview.module').then((m) => m.TopicOverviewModule),
          cmsComponents: ['topic_overview'],
        },
      }
    }),
    {
      provide: TOPIC_OVERVIEW_CONVERTER_TOKEN,
      useClass: TopicOverviewConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        topic_overview: TOPIC_OVERVIEW_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TOPIC_OVERVIEW_ITEM_CONVERTER_TOKEN,
      useClass: TopicOverviewItemConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        topic_overview_item: TOPIC_OVERVIEW_ITEM_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class TopicOverviewFeatureModule {}
